import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

import { baseAssetSchema } from "./assetsBase";

export const bridgeListItemSchema = baseAssetSchema.extend({
  name: z.string(),
  type: z.string(),
  width: z.number().nullable(),
  length: z.number().nullable(),
  height: z.number().nullable(),
});

export type BridgeListItem = z.infer<typeof bridgeListItemSchema>;

export const bridgeListSchema = paginatedSchema(bridgeListItemSchema);
export type BridgeList = z.infer<typeof bridgeListSchema>;

export const bridgeSchema = bridgeListItemSchema;
export type Bridge = z.infer<typeof bridgeSchema>;

export function useBridges(params = {}) {
  const url = combineUrlAndParams("/api/v4/bridges/", params);
  return useParsedQuery<BridgeList>(
    ["lizard-api-v4", "bridges", url],
    () => fetchWithError(url),
    (json: unknown) => bridgeListSchema.parse(json)
  );
}

export function useBridge(id: number) {
  return useParsedQuery<Bridge>(
    ["lizard-api-v4", "bridges", id],
    () => fetchWithError(`/api/v4/bridges/${id}/`),
    (json: unknown) => bridgeSchema.parse(json)
  );
}

export function useMultipleBridges(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "bridges", id],
        fetchFunction: () => fetchWithError(`/api/v4/bridges/${id}/`),
        parseFunction: (json: unknown) => bridgeSchema.parse(json),
      };
    })
  );
}
